import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "./PrvateRouteHelperHook";
import { getSessionUserRole } from "../../api/sessionManagement";
import { USER_ROLES, ROUTE_URLS } from "../../constants/consts";

export const PrivateRoute: React.FC = () => {
  const { isAuthenticated } = useSession();
  const userRole: any = getSessionUserRole();
  const { pathname } = useLocation();

  if (isAuthenticated === null) {
    return <></>;
  }

  if (isAuthenticated === true && userRole === USER_ROLES.UNVERIFIED) {
    return <Navigate to={ROUTE_URLS.LANDING_PAGE} />;
  }

  if (
    (userRole === USER_ROLES.CONFIRMED || userRole === USER_ROLES.WAITING) &&
    ![ROUTE_URLS.QUESTIONARY, ROUTE_URLS.TERM_SERVICE].includes(pathname as ROUTE_URLS)
  ) {
    return <Navigate to={ROUTE_URLS.QUESTIONARY} />;
  }

  if (isAuthenticated === true && !userRole) {
    return <Navigate to={ROUTE_URLS.LANDING_PAGE} />;
  }

  return isAuthenticated ? <Outlet /> : <Navigate to={ROUTE_URLS.LANDING_PAGE} />;
};
